import DateCellRenderer from '../../shared/agGrid/cellRenderers/dateCellRenderer.component';

export const headerColumnDefinitions = [
  { field: 'HDR_ID', headerName: 'Header ID' },
  { field: 'CODE', headerName: 'Code' },
  { field: 'NOTE', headerName: 'Note', minWidth: 300 },
  { field: 'PRG_UNIT', headerName: 'PRG Unit' },
  { field: 'START_TS', headerName: 'Start TS', cellRenderer: DateCellRenderer },
  { field: 'END_TS', headerName: 'End TS', cellRenderer: DateCellRenderer },
  { field: 'CREATED_BY', headerName: 'Created By' },
  { field: 'CREATED_ON', headerName: 'Created On', cellRenderer: DateCellRenderer },
  { field: 'UPDATED_BY', headerName: 'Updated By' },
  { field: 'UPDATED_ON', headerName: 'Updated On', cellRenderer: DateCellRenderer },
];

export const detailColumnDefinitions = [
  { field: 'DTL_ID', headerName: 'Detail ID' },
  { field: 'CODE', headerName: 'Code' },
  { field: 'NOTE', headerName: 'Note', minWidth: 300 },
  { field: 'PRG_UNIT', headerName: 'PRG Unit' },
  { field: 'DATE_TS', headerName: 'Date TS', cellRenderer: DateCellRenderer },
];
